export default "__VITE_ASSET__b551432c__"